import api from './api';

const LOGGED_OUT_KEY = 'loggedOut';

export const setToken = (token) => {
  localStorage.setItem('token', token);
  localStorage.removeItem(LOGGED_OUT_KEY);
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.removeItem(LOGGED_OUT_KEY);
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const removeUser = () => {
  localStorage.removeItem('user');
};

export const setLoggedOut = () => {
  localStorage.setItem(LOGGED_OUT_KEY, '1');
};

export const clearLoggedOut = () => {
  localStorage.removeItem(LOGGED_OUT_KEY);
};

export const isLoggedOut = () => {
  return localStorage.getItem(LOGGED_OUT_KEY) === '1';
};

export const purgeAuth = () => {
  removeToken();
  removeUser();
  setLoggedOut();
};

export const hasRole = (role) => {
  const user = getUser();
  return user && user.roles && user.roles.includes(role);
};

// Vérifier si l'utilisateur a un rôle S-tier (accès module Pro)
export const hasSTier = () => {
  const user = getUser();
  if (!user || !user.roles) return false;
  
  const sTierRoles = ['S_PLAN_5', 'S_PLAN_10', 'S_PLAN_15', 'SITE_PLAN_10'];
  return user.roles.some(role => sTierRoles.includes(role));
};

// Vérifier si l'utilisateur a le plan S_PLAN_3 (peut créer des articles B2B)
export const hasSPlan3 = () => {
  const user = getUser();
  if (!user || !user.roles) return false;
  return user.roles.includes('S_PLAN_3');
};

export const logout = () => {
  purgeAuth();
  window.location.href = '/login';
};

// Rafraîchir les données utilisateur depuis le serveur
export const refreshUser = async () => {
  try {
    const token = getToken();
    if (!token) return null;
    
    const response = await api.get('/auth/me');
    const userData = response.data;
    setUser(userData);
    return userData;
  } catch (error) {
    console.error('Error refreshing user data:', error);
    // Si erreur 401, déconnecter l'utilisateur
    if (error.response?.status === 401) {
      logout();
    }
    return null;
  }
};

// Vérifier et rafraîchir les rôles au chargement de la page
export const checkAndRefreshUser = async () => {
  const token = getToken();
  if (!token) return null;
  
  // Rafraîchir les données utilisateur
  return await refreshUser();
};
